// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._27wDhPtox{overflow:visible !important}._27wDhPtox:focus{outline:none}\n", ""]);
// Exports
exports.locals = {
	"rv-list": "_27wDhPtox",
	"rvList": "_27wDhPtox"
};
module.exports = exports;
